import estilos from './servicios/InformacionD.module.css'
import './servicios/InformacionD.module.css';

function InformacionD({children, children2, titulo, informacion, vinculo, infov}) {
    return (
       <> 
      <h2 className={estilos.h2}>
          {titulo}
      </h2>
      <hr className={estilos.hr} />
      <div className={estilos.div}>
        <div className={estilos.aside}>
          <aside> 
            {informacion}
            <a className={`${estilos.a} ${vinculo === "https://maps.app.goo.gl/vrE7zFQVfXAhXBDp7" ? 'bg-primary' : ''}`} href={vinculo}>{infov}</a>
          </aside>
        </div>
        <div className={estilos.img}>
          <img  src={children} alt={children2} />
        </div>
      </div>
      </>
    );
  };
  
  export default InformacionD;